<template>
  <main>
    <div id="navbar-top">
      <navbar />
    </div>
    <section class="page_welcoming_section">
      <hero-content class="wrapper-hero-content" />
    </section>
    <section class="page_about_section">
      <about-content class="wrapper-about-content" />
    </section>
    <section class="page_portfolio_section">
      <portfolio-content class="wrapper-portfolio-content" />
    </section>
    <section class="page_certificate_section">
      <certificate-content class="wrapper-certificate-content" />
    </section>
    <section class="page_contact_section" style="background-color: #8fd6e1">
      <contact-content class="wrapper-contact-content mt-5" />
    </section>
    <div class="bg-footer">
      <footer-content class="wrapper-footer-content" />
    </div>
    <!-- Copyright Section-->
    <div class="copyright py-3 text-center text-white bg-dark">
      <div class="container">
        <small>Copyright © Altheo Saquilayan's Personnal Website</small>
      </div>
    </div>
    <div>
      <modal-contents />
    </div>
  </main>
</template>

<script>
import HeroContent from "@/components/welcome_section/HeroContent.vue";
import AboutContent from "@/components/about_section/AboutContent.vue";
import PortfolioContent from "@/components/portfolio_section/PortfolioContent.vue";
import CertificateContent from "@/components/certifcate_section/CertificateContent.vue";
import ContactContent from "@/components/contact_section/ContactContent.vue";
import FooterContent from "@/components/FooterContent.vue";

import ModalContents from "@/components/modal_section/ModalContents.vue";

import Navbar from "@/components/Navbar.vue";

export default {
  name: "App",
  components: {
    HeroContent,
    Navbar,
    AboutContent,
    PortfolioContent,
    CertificateContent,
    ModalContents,
    ContactContent,
    FooterContent,
  },
};
//#44c664 SECONDARY COLOR
</script>
<style>
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.wrapper-hero-content {
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  background-color: #8fd6e1;
}
.page_about_section {
  min-height: 80vh;
}
.wrapper-about-content {
  min-height: 40vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
}
.page_portfolio_section {
  min-height: 40vh;
}
.wrapper-portfolio-content {
  min-height: 80vh;
  align-items: center;
  flex-direction: column;
  display: flex;
  background-color: #8fd6e1;
}
.wrapper-certificate-content {
  min-height: 80vh;
  align-items: center;
  flex-direction: column;
  display: flex;
  background-color: white;
}
.wrapper-contact-content {
  min-height: 70vh;
  align-items: center;
  flex-direction: column;
  display: flex;
  background-color: #8fd6e1;
}
.wrapper-footer-content {
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  background-color: #222831;
}
.bg-footer {
  background-color: #222831;
}
</style>
